import {createTheme} from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2C9138',
    },
    secondary: {
      main: '#111827',
    },
    error: {
      light: '#e57373',
      main: '#f44336',
      dark: '#d32f2f',
      contrastText: '#fff',
    },
    grey: {
      50: `#F9FAFB`,
      100: `#F3F4F6`,
      200: `#E5E7EB`,
      300: `#D1D5DB`,
      400: `#9CA3AF`,
      500: `#6B7280`,
      600: `#4B5563`,
      700: `#374151`,
      800: `#1F2937`,
      900: `#111827`,
    },
  },
  typography: {
    // fontSize: 16,
    fontFamily: [
      'Inter',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});

export default theme;
